export const REGISTER_ERRORS = {
    'email': 'Correo Electrónico',
    'Este campo debe ser único.': 'Ya existe un usuario registado con el correo electrónico que ingresó.',
    'password': 'Contraseña',
    'Esta contraseña es demasiado común.': 'Por favor, utilice una contraseña más segura. Debe tener al menos una letra.',
    'username': 'Nombre de usuario',
    'Ya existe un usuario con este nombre.': 'Ya existe un usuario registado con el nombre de usuario que ingresó.',
    'invalid_grant': 'Usuario o contraseña incorrectos',
    'Invalid credentials given.': 'Se proporcionaron credenciales no válidas o su usuario no esta activado',
    'invalid_request':'El sistema no pudo procesar su solicitud',
    'cuit': 'CUIT',
    'Email & Password does not match with our record.': 'Usuario o contraseña incorrectos',
}